import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await api.post('/users/password-reset/', { email });
      setSubmitted(true);
    } catch {
      setError('Something went wrong. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg)',
    }}>
      <div style={{
        background: 'var(--bg2)', border: '1px solid var(--border)',
        borderRadius: 16, padding: 40, width: '100%', maxWidth: 400,
        boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>🎵</div>
          <h1 style={{ fontSize: 24, fontWeight: 700, margin: 0 }}>Reset Password</h1>
          <p style={{ color: 'var(--text-muted)', marginTop: 8, fontSize: 14 }}>
            Enter your email and we'll send you a reset link
          </p>
        </div>

        {submitted ? (
          <div style={{
            background: 'rgba(50,205,50,0.1)', border: '1px solid rgba(50,205,50,0.3)',
            borderRadius: 8, padding: '14px', textAlign: 'center', color: '#6ddb6d', fontSize: 14,
          }}>
            Check your email for a reset link.
          </div>
        ) : (
          <>
            {error && (
              <div style={{
                background: 'rgba(255,50,50,0.15)', border: '1px solid rgba(255,50,50,0.3)',
                borderRadius: 8, padding: '10px 14px', marginBottom: 20,
                color: '#ff6b6b', fontSize: 13,
              }}>
                {error}
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: 24 }}>
                <label style={{ display: 'block', fontSize: 13, color: 'var(--text-muted)', marginBottom: 6 }}>
                  Email address
                </label>
                <input
                  className="search-input"
                  style={{ width: '100%', boxSizing: 'border-box' }}
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  autoFocus
                />
              </div>
              <button
                className="btn btn-primary"
                style={{ width: '100%', padding: '10px', fontSize: 15 }}
                type="submit"
                disabled={loading}
              >
                {loading ? 'Sending…' : 'Send Reset Link'}
              </button>
            </form>
          </>
        )}

        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: 'var(--text-muted)' }}>
          <Link to="/login" style={{ color: 'var(--text-muted)' }}>Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
